import PropTypes from "prop-types";
import { Badge } from "@/components/ui/badge";
import { verdictLabel } from "./lib/format";

// Own is the moss of "yes", Watch the amber of "not yet", Avoid a plain
// "no" (the brick is for errors and deletes, not 1,000 rows), Unreviewed
// an outline: nothing decided.
const VARIANTS = {
  own: "success",
  watch: "warning",
  avoid: "secondary",
  unreviewed: "outline",
};

/** A verdict, with its conviction when there is one: "Own · 4". */
function VerdictBadge({ verdict, conviction = null, className }) {
  const withConviction =
    conviction !== null && conviction !== undefined && verdict !== "unreviewed";
  return (
    <Badge variant={VARIANTS[verdict] || "outline"} className={className}>
      {verdictLabel(verdict)}
      {withConviction && ` · ${conviction}`}
    </Badge>
  );
}

VerdictBadge.propTypes = {
  verdict: PropTypes.string.isRequired,
  conviction: PropTypes.number,
  className: PropTypes.string,
};

export default VerdictBadge;
